'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdFlashAuto = function MdFlashAuto(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm28 12.7h4l-2-6.1z m3.6-9.3l5.4 15h-3.2l-1.1-3.4h-5.4l-1.1 3.4h-3.2l5.4-15h3.2z m-26.6 0h16.6l-6.6 15h6.6l-11.6 20v-15h-5v-20z' })
        )
    );
};

exports.default = MdFlashAuto;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/flash-auto.js
// module id = 1471
// module chunks = 168707334958949